export default {
  id: 145,
  title: 'Target #145 - Spotlight',
  url: 'https://cssbattle.dev/play/145',
  colors: ['#E3516E', '#D9D9D9'],
  solution:
    '<a a><a b><style>[a],[b]{width:150}body{background:#e3516e}a{position:fixed;background:#d9d9d9}[a]{height:150;right:0;top:0}[b]{height:200;transform:rotate(45deg);border-radius:9in;right:32;top:7}</style>',
}
